module.exports = {
    API_URL : "https://cryptotracker-backend-r4fi.onrender.com/"
}